export default "__VITE_ASSET__RF8$8yGA__"